import { REQUIRED_CONSENT_FORM_BLOCKS } from '@westhetics/legal'

/**
 * Coloca um bloco obrigatório do termo no lugar dele: depois do front matter e do título, e depois
 * dos blocos obrigatórios que vêm antes na ordem de leitura (resumo · autorização · riscos). O bloco
 * entra vazio, de propósito: o aviso de bloco vazio fica na tela até alguém escrever.
 */
export function insertRequiredBlock(markdown: string, name: string): string {
  const lines = markdown.split('\n')
  let at = 0

  if (lines[0]?.trim() === '---') {
    const end = lines.findIndex((line, index) => index > 0 && line.trim() === '---')
    if (end > 0) at = end + 1
  }
  while (at < lines.length && lines[at]?.trim() === '') at += 1
  if (/^#\s/.test(lines[at] ?? '')) at += 1

  const order = REQUIRED_CONSENT_FORM_BLOCKS as readonly string[]
  const position = order.indexOf(name)
  for (const previous of order.slice(0, Math.max(position, 0))) {
    const start = lines.findIndex((line) => new RegExp(`^:::${previous}(\\{|\\s|$)`).test(line))
    if (start < 0) continue
    const end = lines.findIndex((line, index) => index > start && line.trim() === ':::')
    if (end > start) at = Math.max(at, end + 1)
  }

  const before = lines.slice(0, at)
  while (before.length && before[before.length - 1]?.trim() === '') before.pop()
  const after = lines.slice(at)
  const out = [...before]
  if (out.length) out.push('')
  out.push(`:::${name}`, '', ':::')
  if (!after.length) out.push('')
  else {
    if (after[0]?.trim() !== '') out.push('')
    out.push(...after)
  }
  return out.join('\n')
}
